import { __makeTemplateObject } from "tslib";
import React, { Children, forwardRef, isValidElement, useMemo, useRef, } from 'react';
import styled from 'styled-components';
import { v4 as uuidv4 } from 'uuid';
import { FormFieldLabel, } from '../FormFieldLabel/FormFieldLabel';
import { FormFieldContextProvider, } from './FormFieldContext/FormFieldContext';
import { FormFieldHelperText, } from '../FormFieldHelperText/FormFieldHelperText';
import { boxSizingBorderBox } from '../../utils/styled-components/extends';
export var FormField = forwardRef(function (_a, ref) {
    var children = _a.children, idProp = _a.id, className = _a.className, inputIdProp = _a.inputId, groupProp = _a.group, label = _a.label, hint = _a.hint, tooltip = _a.tooltip, error = _a.error, errorMessage = _a.errorMessage, warning = _a.warning, warningMessage = _a.warningMessage, success = _a.success, successMessage = _a.successMessage, withFeedbackIcon = _a.withFeedbackIcon, required = _a.required, disabled = _a.disabled, readOnly = _a.readOnly, size = _a.size;
    var group = groupProp !== undefined ? groupProp : hasGroupChild(children);
    var _b = useIds({
        root: idProp,
        input: inputIdProp,
    }), id = _b.id, inputId = _b.inputId, helperTextId = _b.helperTextId, labelId = _b.labelId;
    error = errorMessage ? true : error;
    warning = warningMessage ? true : warning;
    success = successMessage ? true : success;
    var helperText = errorMessage || warningMessage || successMessage || undefined;
    var contextValue = {
        error: error,
        warning: warning,
        success: success,
        withFeedbackIcon: withFeedbackIcon,
        ariaDescribedby: helperText ? helperTextId : undefined,
        size: size,
        required: required,
        disabled: disabled,
        readOnly: readOnly,
        inputId: group ? undefined : inputId,
    };
    return (React.createElement(FormFieldContextProvider, { value: contextValue },
        React.createElement(SRoot, { as: group ? 'fieldset' : 'div', ref: ref, className: className, id: id },
            label && (React.createElement(FormFieldLabel, { component: group ? 'legend' : 'label', htmlFor: inputId, hint: hint, required: required, error: error, tooltip: tooltip, id: labelId }, label)),
            children,
            helperText && (React.createElement(FormFieldHelperText, { id: helperTextId, type: getFormFieldHelperTextType({ error: error, warning: warning, success: success }) }, helperText)))));
});
export var FormFieldIdSuffixes = {
    input: '_input',
    helperText: '_helper-text',
    label: '_label',
};
var SRoot = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n  border: 0;\n  padding: 0;\n  margin: 0;\n  // fieldsets have a min-width of content, should be overridden.\n  min-width: 0;\n"], ["\n  ", ";\n  border: 0;\n  padding: 0;\n  margin: 0;\n  // fieldsets have a min-width of content, should be overridden.\n  min-width: 0;\n"])), boxSizingBorderBox);
function hasGroupChild(children) {
    return (Children.count(children) === 1 &&
        isValidElement(children) &&
        'type' in children &&
        children.type.GROUP === true);
}
function getFormFieldHelperTextType(_a) {
    var error = _a.error, warning = _a.warning, success = _a.success;
    return error ? 'error' : warning ? 'warning' : success ? 'success' : undefined;
}
function useIds(idProps) {
    var uniqueIdRef = useRef(uuidv4());
    return useMemo(function () {
        var _id = idProps.root || uniqueIdRef.current;
        return {
            id: _id,
            inputId: idProps.input || _id + FormFieldIdSuffixes.input,
            helperTextId: _id + FormFieldIdSuffixes.helperText,
            labelId: _id + FormFieldIdSuffixes.label,
        };
    }, [idProps.root, idProps.input]);
}
var templateObject_1;
//# sourceMappingURL=FormField.js.map